// Global
import React from 'react';
// Local
import { Content } from '@generated/Content/Iframe.model';
import { Iframe } from './Iframe';
import PlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';

type IframeProps = Content.Iframe.Iframe_Component;

export const Default = (props: IframeProps) => {
  /*
   * Rendering
   */

  if (!props.fields) {
    return <></>;
  }

  return (
    <Iframe
      headline={<PlainTextWrapper field={props.fields?.title} />}
      height={props.fields?.height?.value}
      iframeUrl={props.fields?.iframeUrl?.value}
      width={props.fields?.width?.value}
      allowLocalNetworkAccess={props.fields?.allowLocalNetworkAccess?.value}
    />
  );
};
